import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 記録者名
 */
export class RecorderName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): RecorderName {
    return new RecorderName(value);
  }
}
